import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/TempImg.jpg'


const _withScopeId = n => (_pushScopeId("data-v-c8a451e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "official" }
const _hoisted_2 = {
  key: 0,
  class: "officialsContainer"
}
const _hoisted_3 = { class: "officialsMainContainer" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "landsTraener",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "membersOfficialRole" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "membersOfficialRole" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "membersOfficialRole" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "membersOfficialRole" }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { class: "membersOfficialRole" }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = { class: "membersOfficialRole" }
const _hoisted_19 = { key: 6 }
const _hoisted_20 = { class: "membersOfficialRole" }
const _hoisted_21 = { key: 7 }
const _hoisted_22 = { key: 8 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.officialMembers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.officialMembers, (member) => {
              return (_openBlock(), _createBlock(_component_va_card, {
                class: "officialsContain",
                key: member.id
              }, {
                default: _withCtx(() => [
                  (member?.official__billede_url)
                    ? (_openBlock(), _createBlock(_component_va_image, {
                        key: 0,
                        src: `${_ctx.APIURL}${member.official__billede_url}`,
                        alt: "landsTraener"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)),
                  _createVNode(_component_va_card_title, { class: "officialsCardTitle" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(member?.official_navn), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "officialsCardContent" }, {
                    default: _withCtx(() => [
                      (_ctx.selectedSlugType === 'landstraenere-og-elitechef' && member.official_landstraenertype)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_landstraenertype))) + "landstræner", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'bestyrelse' && member.official_type)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                            _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_type))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'eliteudvalg' && member.official_udvalgtype)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                            _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_udvalgtype))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'ungdomsudvalg' && member.official_udvalgtype && member.official_udvalgtype !== 'raadgiver')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                            _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_udvalgtype))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'staevneudvalg' && member.official_udvalgtype)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                            _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_udvalgtype))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'turneringsudvalg' && member.official_udvalgtype)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                            _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_udvalgtype))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedSlugType === 'paradart-udvalget' && member.official_udvalgtype)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                            _createElementVNode("strong", _hoisted_20, _toDisplayString(_ctx.replaceSpecialCharacters(_ctx.makeOfficialTypeStr(member.official_udvalgtype))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (member?.official_telefon)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                            _createVNode(_component_va_icon, { name: "call" }),
                            _createElementVNode("strong", null, " : " + _toDisplayString(member.official_telefon), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (member?.official_email)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                            _createVNode(_component_va_icon, { name: "mail" }),
                            _createElementVNode("strong", null, [
                              _hoisted_23,
                              _createElementVNode("a", {
                                href: `mailto:${member.official_email}`,
                                target: "_blank"
                              }, _toDisplayString(member.official_email), 9, _hoisted_24)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}